import { actionTypes } from '@buffer-mono/async-data-fetch'

type MaintenanceAction = {
  type: string
  error: string
}

type Next = (action: MaintenanceAction) => unknown

export default () =>
  (next: Next) =>
  (action: MaintenanceAction): void => {
    next(action)
    if (
      action.type.endsWith(actionTypes.FETCH_FAIL) &&
      action.error.includes(
        'Buffer is under maintenance, please, try again soon',
      ) &&
      action.error.includes('503')
    ) {
      window.location.replace('/maintenance')
    }
  }
